import React from 'react';
import { Text, VStack } from '@chakra-ui/react';
import { SheetButton, SheetFooter } from '../../components/counter-flow/sheetParts';
import WizardSheet from './WizardSheet';

interface CancelCollabWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
}

const CancelCollabWarningModal: React.FC<CancelCollabWarningModalProps> = ({
  isOpen,
  onClose,
  onContinue,
}) => (
  <WizardSheet isOpen={isOpen} onClose={onClose} title="Canceling this collab will impact your Creator Score">
    <VStack spacing="12px" align="stretch" fontSize="15px" lineHeight="1.45" color="#3E3E42">
      <Text m={0}>
        By canceling this collaboration, you acknowledge that it will lower your Creator Score — which directly affects how many paid opportunities you're invited to in the future. A lower score means fewer invites and less visibility to top brands.
      </Text>
      <Text m={0}>
        In many cases, the brand has already planned around your participation — cancellations not only hurt your score but also damage trust with the brand.
      </Text>
      <Text m={0} fontWeight={600} color="#0E0E0E">
        Please only cancel if absolutely necessary.
      </Text>
    </VStack>
    <SheetFooter>
      <SheetButton tone="redOutline" onClick={onContinue}>Cancel Anyway</SheetButton>
      <SheetButton onClick={onClose}>Keep Collab</SheetButton>
    </SheetFooter>
  </WizardSheet>
);

export default CancelCollabWarningModal;
